const mutations = {
    setCompanies(state,payload) {
        state.companies = payload
    },
    setUsersForCompany(state,payload){
        state.users = payload
    },
}

export default mutations